import React from 'react'
import styled from 'styled-components'
import { useAuthService } from '../../Context/AuthContext';
import { displayUserAvatar } from '../../Helpers/chatHelper/AvatarHelper';
import { ReactComponent as ProIcon } from "../../Assets/iconsv2/generic/PremiumUser.svg"
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg"
import { ReactComponent as PlatformIconLight } from "../../Assets/iconsv2/generic/BusinessUserLight.svg"
import { useGenericComponentsStateService } from '../../Context/GenericComponentsStateContext';

const ProfileButton = ({ selected, containertStyle, onClick }) => {

    const { user } = useAuthService();
    const { theme } = useGenericComponentsStateService()
    return (
        <Container style={containertStyle} onClick={onClick} selected={selected}>
            <IconWrapper selected={selected}>
                {displayUserAvatar(user)}


                {user.is_pro_from_platform ? (
                    <ProWrapper>
                        {theme === "light" ? <PlatformIconLight /> : <PlatformIcon />}
                    </ProWrapper>
                ) :
                    user.is_pro && <ProWrapper>
                        <ProIcon />
                    </ProWrapper>
                }
            </IconWrapper >

        </Container>
    )
}

export default ProfileButton

const Container = styled.div`
display:flex;
align-items:center;
justify-content:center;
width:100%;
flex-direction:column;
cursor:pointer;
gap:6px;
border-radius:4px;
background:${({ selected, theme }) => selected ? theme.sidebar.selectedBtnBackground : "transparent"};
min-height:54px;
`
const IconWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
width:42px;
height:42px;
color:${({ selected, theme }) => selected ? theme.sidebar.selectedIconColor : theme.sidebar.iconColor};
position:relative;
`

const ProWrapper = styled.div`
display:flex;
align-items:center;
position:absolute;
bottom:-5px;
right:-5px;
height:22px;
width:22px;
svg{
color:${({ theme }) => theme.loginButton.background};
}
`
